import { render, staticRenderFns } from "./edit_addon.vue?vue&type=template&id=5d9d1bce&scoped=true"
import script from "./edit_addon.vue?vue&type=script&lang=js"
export * from "./edit_addon.vue?vue&type=script&lang=js"
import style0 from "./edit_addon.vue?vue&type=style&index=0&id=5d9d1bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d1bce",
  null
  
)

export default component.exports